export const order = {
  ALL: 'Todos',

  // Experience
  JOB: 'Trabajos',

  // Certificates
  COURSE: 'Cursos',
  EXAM: 'Exámenes',
  DEGREE: 'Títulos',

  // Projects
  WEB: 'Sitios Web',
  MOBILE: 'Aplicaciones Móviles',
  PERSONAL_PROJECTS: 'Proyectos Personales',

  // Publications
  UNLP: 'LIFIA - UNLP',
  THESIS: 'Tesis',
  JOURNAL: 'Revistas',
  CONFERENCE: 'Conferencias',

  // Skills
  CURRENT: 'Actualmente usando',
  PAST_FREQUENTLY: 'Usé en el pasado',
  PAST_OCCASIONALLY: 'Algo de conocimiento en',
};
